export const COMPOSER_CHIPS = [
  { key: "startAdvisory", labelKey: "simonBar.chips.startAdvisory" },
  { key: "newClient", labelKey: "advice.newClient.title" },
] as const;

export type ComposerChipKey = (typeof COMPOSER_CHIPS)[number]["key"];

export function chipsThatFit(widths: readonly number[], gap: number, available: number): number {
  let used = 0;
  for (let index = 0; index < widths.length; index++) {
    used += widths[index] + (index > 0 ? gap : 0);
    if (used > available) return index;
  }
  return widths.length;
}
